const convert = require("convert-pro").default;

module.exports = convert.bytes;
module.exports.default = convert.bytes;
